import { render, staticRenderFns } from "./CardDescription.vue?vue&type=template&id=148293ce&scoped=true&"
import script from "./CardDescription.vue?vue&type=script&lang=js&"
export * from "./CardDescription.vue?vue&type=script&lang=js&"
import style0 from "./CardDescription.vue?vue&type=style&index=0&id=148293ce&lang=scss&scoped=true&"
import style1 from "./CardDescription.vue?vue&type=style&index=1&id=148293ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148293ce",
  null
  
)

export default component.exports